import { surfaceColorBackgroundDarkBlue, supportBorderColorWarning } from 'styles/designTokens';

export const FOOTER_COLORS = {
    BACKGROUND: surfaceColorBackgroundDarkBlue,
    BORDER: supportBorderColorWarning,
};

export const SOCIAL_LINKS = {
    X: 'https://x.com/bc_eao?lang=en',
};
